import { SubscriptionClient, WebSocketTransport } from '@nktkas/hyperliquid';

const transport = new WebSocketTransport();
const subsClient = new SubscriptionClient({ transport });
export function getSubsClientInstance() {
  return subsClient;
}
